import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "validity-amount" }
const _hoisted_3 = { class: "counter" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", { class: "ps-3 pt-2 sm" }, "Validity period for this category in DAYS.", -1)
const _hoisted_5 = {
  for: "top-checkbox",
  class: "mt-4 d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", { class: "ms-3" }, "Active", -1)
const _hoisted_7 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, _mergeProps({ title: _ctx.modalTitle }, _ctx.$props, { onHide: _ctx.hideHandler }), {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(_component_AppInputsValidationProvider, {
          "shake-tree": _ctx.parentTouched,
          onChangeErrorState: _ctx.onChangeErrorState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppInput, {
              id: "new-validity-period-title",
              modelValue: _ctx.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
              "input-type": "material",
              "validation-type": "name",
              type: "text",
              label: "Title"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", {
                    class: "counter-decr counter-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.decrease()))
                  }, "-"),
                  _createElementVNode("output", null, _toDisplayString(_ctx.period), 1),
                  _createElementVNode("span", {
                    class: "counter-incr counter-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.increase()))
                  }, "+")
                ]),
                _createVNode(_component_AppInput, {
                  id: "new-validity-period-amount",
                  modelValue: _ctx.period,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.period) = $event)),
                  "input-type": "material",
                  "static-focused": true,
                  label: "Validity",
                  type: "number"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_4
            ])
          ]),
          _: 1
        }, 8, ["shake-tree", "onChangeErrorState"]),
        _createElementVNode("label", _hoisted_5, [
          _createVNode(_component_AppCheckbox, {
            id: "top-checkbox",
            modelValue: _ctx.active,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.active) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_AppButton, {
            size: "xl",
            disabled: !_ctx.valid,
            type: "secondary",
            onClick: _ctx.submitHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.modalTitle), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["title", "onHide"]))
}